import { RouteObject } from "react-router";
import NewFieldProperties from "./NewFieldProperties";

const routes: RouteObject = {
  path: "new",
  Component: NewFieldProperties,
};

export default routes;
